import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class TwoIntro extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_vegetative_2.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>
        Part II: The Growing Process
        </h2>
        <p>
        In Part II we dive into the actual growing process step by step, and watch our plant grow from seed to harvest. Before beginning the growing process you should already have your grow space set up and ready to house your new plants. Even though the full grow takes several months, you will be amazed at the speed and progress your plants make every day. 
        </p>
        <h3>Keep a journal</h3>
        <p>
        All the steps in the grow process are time sensitive. Your first step should be starting a journal or calendar where you keep track of feedings and important milestones. This is especially important if you are growing with more than one person. Things like overwatering can be detrimental to your plants, so keeping a record near your plants that anyone can reference will make sure your plants are getting the exact attention they need. A calendar will also allow you to estimate when important dates likes switching to flowering or harvesting should happen, allowing you to properly monitor your plants for the cues that will let you know the plant is ready. 
        </p>
        <p>
        If you’re prepared to provide your plants with the the daily attention and care they need to thrive, you’ll be more than satisfied with the results of your hard work. 
        </p>
        <GuideButton slugTo="germinating-seeds" />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/two_intro.js